import GenericAction from '@Actions/generic-action';
import { clearAuthSessionStorage } from "@Helpers/clear-auth-session-storage";
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

export default class Login extends GenericAction {
  runAction() {
    const Action = async () => {
      try {
        await signInWithEmailAndPassword(getAuth(), this._payload.email, (this._payload.pass || this._payload.password))
        this.onSuccess();
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { type: AnalyticsEvents.user_login }
        });
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }

  onSuccess(response) {
    // Clear session storage to remove user critical data between logins: EG: switchable profiles
    clearAuthSessionStorage({ preserveLocale: true });
    // Set lastAuthDTS state for reAuth security checking by AuthService
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        auth: {
          lastAuthDTS: new Date().getTime()
        }
      }
    });

    super.onSuccess(response);
  }
}
